module.exports = "<button class=\"btn btn-outline-black\" type=\"button\">\r\n{{label}}</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/button/button.component.html
// module id = 1185
// module chunks = 322